export class ChangePasswordModel {
  constructor(public OldPassword: string,
              public NewPassword: string,
              public ConfirmPassword: string) {
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/user/change-password.model.ts